import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CartService } from '../../cart-detail/cart.service';
import { ProductService } from '../../product-list/product-list.service';
import { Config } from '../../services/env.config';
import { UploadFormComponent } from '../../cart-detail/add-to-cart/add-to-cart.component';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { NavbarFiltersAttributes } from '../../product-list/product';
import { ChangePasswordComponent } from '../../auth/change-password/change-password.component';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SuccessDialogComponent } from 'src/app/shared/success-dialog/success-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SchemePopupComponent } from '../scheme-popup/scheme-popup.component';
import { ImagePopupComponent } from '../image-popup/image-popup.component';
import { ServerBranch } from 'src/assets/serverBranch';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  public show: boolean = false;
  selectdealer: boolean = false;
  dealerselected: any;
  selectdealerName: any;
  desigName: string = '';
  distributor: string = '';
  loggedInUserDetail: any;
  cartProductCount: number;
  configUrl = Config.BaseEndpoint;
  mySubscription: any;
  modulevisibility: any;
  items: any;
visibility : any;
moduleMaster: boolean = false;
moduleMyOrder: boolean = false;
moduleSalesPerformance: boolean = false;
checkAdmin:any;
countryImagePath:any;
  constructor(private router: Router, private http: HttpClient, private cartService: CartService, private productService: ProductService, private modalService: MDBModalService) {
    this.cartProductCount = this.cartService.cartProductCount;
    this.countryImagePath = JSON.parse(sessionStorage.getItem('countryImagePath'))
    this.loggedInUserDetail = JSON.parse(sessionStorage.getItem('user'));
    this.checkAdmin= this.loggedInUserDetail.UserName
    this.selectdealer = JSON.parse(sessionStorage.getItem('RSSO'));
    this.selectdealerName = JSON.parse(sessionStorage.getItem('DealUserName'));
    console.log(this.selectdealerName)
    this.modulevisibility = JSON.parse(sessionStorage.getItem('modulevisibility'));
    if(this.modulevisibility) {
    for( let i =0 ; i< this.modulevisibility.length ; i++ ) {
       if(this.modulevisibility[i].ModuleName == "Master Data" && this.modulevisibility[i].ViewAccess) {
         this.moduleMaster = true;
       }
       if(this.modulevisibility[i].ModuleName == "My Order" && this.modulevisibility[i].ViewAccess) {
        this.moduleMyOrder = true;
      }
      if(this.modulevisibility[i].ModuleName == "Sales Performance" && this.modulevisibility[i].ViewAccess) {
        this.moduleSalesPerformance = true;
      }
    }
  }

    console.log('nav cld')
    if (this.loggedInUserDetail.DesigName) {
      this.desigName = this.loggedInUserDetail.DesigName;
      this.distributor = this.loggedInUserDetail.Name;
    }


    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };

  uploadFormRef: MDBModalRef;
  openUploadForm() {
    let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('user'));
    if (RSSO) {
      if (Deal && (Deal.DealUserName != User.UserName)) {
        this.uploadFormRef = this.modalService.show(UploadFormComponent, {
          data: {
            message: ''
          }
        });
        this.uploadFormRef.content.action.subscribe((result: any) => {
          if (result == 'yes') {
            
            this.cartService.getCartDetailsForUser().then((data: any) => {
              setTimeout(x => {
                this.uploadFormRef.hide();
              }, 300)
            })
          }
        });
      } else {
        let data = [];
        this.changePswdmodalRef = this.modalService.show(SuccessDialogComponent, {
          data: {
            message: 'Please Select dealer',
            data: data
          }
        });
        this.changePswdmodalRef.content.action.subscribe(result => {
          if (result == 'OK') {
            this.changePswdmodalRef.hide();
          }
        })
      }
    }
    else {
      this.uploadFormRef = this.modalService.show(UploadFormComponent, {
        data: {
          message: ''
        }
      });
      this.uploadFormRef.content.action.subscribe((result: any) => {
        if (result == 'yes') {
          //debugger;
          // this.cartService.getCartDetailsForUser().then((data: any) => {
          //   setTimeout(x => {
          //     this.uploadFormRef.hide();
          //   }, 300)
          // })
        }
      });
    }
    
  }

  getUserData() {
    console.log("yes")
    let data = JSON.parse(sessionStorage.getItem('user'));
    let user = { UserName: data.UserName, TokenId: data.TokenId };
    this.http.post(Config.BaseEndpoint + '/GetAccess', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        let user =  JSON.parse(response[0]);
        user = user[0];
        console.log(user)
        sessionStorage.setItem('userDetails', JSON.stringify(user));
        this.desigName = user.DesigName;
        this.distributor = user.Name;
        this.modulevisibility = JSON.parse(response[1]);
        sessionStorage.setItem('modulevisibility', JSON.stringify(this.modulevisibility));
        for( let i =0 ; i< this.modulevisibility.length ; i++ ) {
          if(this.modulevisibility[i].ModuleName == "Master Data" && this.modulevisibility[i].ViewAccess) {
            this.moduleMaster = true;
          }
          if(this.modulevisibility[i].ModuleName == "My Order" && this.modulevisibility[i].ViewAccess) {
           this.moduleMyOrder = true;
         }
       }
      })
      .catch((error) => {
        Promise.reject(error);
      });
  }
  cartCount: number = 0;
  async ngOnInit() {
    this.getDealer();
    // this.getAllCategories();
    this.getCartCount();
    this.getProductTypeList();
    this.getSchemeMaster();
    this.getTaskMaster();
    // if (this.desigName == '') {
      this.getUserData();
    //}
    this.cartService.prodCountCountChange.subscribe(
      (newProdCount) => {
        this.cartCount = newProdCount
        this.countPadding = '8px';
        setTimeout(x => {
          this.countPadding = '4px';
        }, 400)
      }

    );
    this.getAllFilterType()
  }
  changeWidth = "0";
  openNav() {
    console.log('opn')
    document.getElementById("mySidenav").style.width = "250px";
    // this.changeWidth = "250px"
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }


  ngOnDestroy() {
    // this.cartService.prodCountCountChange.unsubscribe();
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }
  
  ViewScheme(id)  {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let user = { UserName : data.UserName , SchemeMgmtId: id } ;
    return this.http
      .post(Config.BaseEndpoint + '/DownloadFile', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((data: any) => {
        if (data.FileData) {
            // Download PDF in Chrome etc.
            const source = `data:application/pdf;base64,${data.FileData}`;
            const link = document.createElement("a");
            link.href = source;
            link.download =data.FileName;
            link.click();
        
        }
       
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  noDataFlag: boolean = true;
  target: any [] = []; 
  table_data: any[] = [];
  className: any = "col-md-12";
  countPadding: string = '4px';
  schemeImageClass : any =  "col-md-6 text-center";
  schemeDataClass : any = "col-md-12 col-lg-6";
   dateTime = new Date();
   dealerLogin: boolean = false;
   year =  this.dateTime.getFullYear();
   month = this.dateTime.toLocaleString('default', { month: 'long' });
  getSchemeMaster() {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
     let user = { UserName : data.UserName , DealUserName : DealUserName, ContentFlag : true }; 
    this.http.post(Config.BaseEndpoint + '/GetContent' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        if(response.length > 0) {
          this.table_data = response;
          if(this.table_data.length == 3) {
            this.className = "col-md-4";
            this.schemeImageClass = "col-md-12 text-center";
            this.schemeDataClass = "col-md-12 col-lg-12";
          } else if(this.table_data.length == 2) {
            this.className = "col-md-6";
            this.schemeImageClass = "col-md-6 text-center";
            this.schemeDataClass = "col-md-12 col-lg-6"
          }else if(this.table_data.length == 1) {
            this.className = "col-md-12";
            this.schemeImageClass = "col-md-6 text-center";
            this.schemeDataClass = "col-md-12 col-lg-6";
          }
          for(let i = 0; i < this.table_data.length ; i ++) {
            this.table_data[i]['divStatusOpen'] = true
          }
          
          this.noDataFlag = true;
        } else {
          this.noDataFlag = false;
        }
       
      })
    .catch((error) => {
      console.log(Promise.reject(error));
    });
  }
  schemeModalRef: MDBModalRef;
openScheme(data) {
  console.log(data);
  this.schemeModalRef = this.modalService.show(SchemePopupComponent, {
    data: {
      message: '',
      data: data
    }
  });
  this.schemeModalRef.content.action.subscribe((result: any) => {
    if (result == 'OK') {
     
          this.schemeModalRef.hide();
       
    }
  });
}
isActive: boolean = false;

  getCartCount() {
    this.cartService.getCartCount().then((response) => {
      // this.cartProductCount = response.length;
    })
  }
  toggleAccordian(event) {
    const element = event.target;
    element.classList.toggle("active");
    if (this.isActive) {
      this.isActive = false;
    } else {
      this.isActive = true;
    }
    const panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
  getDealer() {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let user = { UserName: data.UserName };
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    this.http.post(Config.BaseEndpoint + '/GetDealer', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        this.items = response;
        if(response) {
        for (let i = 0; i < this.items.length; i++) {
          if (Deal && (Deal.DealUserName == this.items[i].DealUserName)) {
            this.dealerselected = this.items[i];
          }
        }
      }
      })
      .catch((error) => {
        Promise.reject(error);
      });
  }
  getTaskMaster() {
 
    let data1 = JSON.parse(sessionStorage.getItem('user')) ;
    let DealUserName;
    if(data1.DealUserName){
     DealUserName = data1.DealUserName;
    }
     let user = { UserName : data1.UserName , DealUserName: DealUserName }; 
     let data = JSON.parse(sessionStorage.getItem('userDetails')) ;
     if(data){
     if(data.DesigId == 2 || data.DesigId == 3) {
       this.dealerLogin = true;
     }
   }
    this.http.post(Config.BaseEndpoint + '/GetDealerTarget' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        if(response.length > 0) {
          this.target = response;
         
        } 
       
      })
    .catch((error) => {
      console.log(Promise.reject(error));
    });
  }

  toggleAccordian1(event) {
    const element = event.target;
    element.classList.toggle("active");
    if (this.isActive) {
      this.isActive = false;
    } else {
      this.isActive = true;
    }
    const panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
  over() {
    document.getElementById('dropdownMenu').style.display = "block"
  }

  changePswdmodalRef: MDBModalRef;
  openChangePasswordBox() {
    this.changePswdmodalRef = this.modalService.show(ChangePasswordComponent, {
      data: {
        message: ''
      }
    });
    this.changePswdmodalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
        setTimeout(x => {
          this.changePswdmodalRef.hide();
        }, 300)
      }
    });
  }

  openDashboard() {
    this.router.navigate(['/main/dashboard']);
  }
  closeDropdown(e) {
console.log(e.target.style.visibility )
if(e.target.style.visibility == "visible") {
e.target.style.visibility = "hidden";
e.target.style.opacity = 0;
}
  }
  openDropdown(e){
    // e.stopPropagation();
    var element = e.target;
    var panel = element.nextElementSibling;
  if(panel.style.visibility == "visible") {
    panel.style.visibility = "hidden";
    panel.style.opacity = 0;
} else {
  panel.style.visibility = "visible";
  panel.style.opacity = 1;
}
 }

  openMyOrder() {
    let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('user'));
    sessionStorage.removeItem("currentScrollYonSession");
    sessionStorage.removeItem("pagenumber");
    sessionStorage.removeItem("productlist");
    if (RSSO) {
      if (Deal && (Deal.DealUserName != User.UserName)) {
        this.router.navigate(['/main/cart/my-orders']);
      } else {
        let data = [];
        this.changePswdmodalRef = this.modalService.show(SuccessDialogComponent, {
          data: {
            message: 'Please Select dealer',
            data: data
          }
        });
        this.changePswdmodalRef.content.action.subscribe(result => {
          if (result == 'OK') {
            this.changePswdmodalRef.hide();
          }
        })
      }
    }
    else {
      this.router.navigate(['/main/cart/my-orders']);
    }
  }
  openMyOrderForIbdAssociate() {
     let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('user'));
    sessionStorage.removeItem("currentScrollYonSession");
    sessionStorage.removeItem("pagenumber");
    sessionStorage.removeItem("productlist");
    if (RSSO) {
      if (Deal && (Deal.DealUserName != User.UserName)) {
        this.router.navigate(['/main/cart/payment-checkout']);
      } else {
        let data = [];
        this.changePswdmodalRef = this.modalService.show(SuccessDialogComponent, {
          data: {
            message: 'Please Select dealer',
            data: data
          }
        });
        this.changePswdmodalRef.content.action.subscribe(result => {
          if (result == 'OK') {
            this.changePswdmodalRef.hide();
          }
        })
      }
    }
    else {
      this.router.navigate(['/main/cart/payment-checkout']);
    }
  }

  openMySecondarySale() {
    let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('user'));
    sessionStorage.removeItem("currentScrollYonSession");
    sessionStorage.removeItem("pagenumber");
    sessionStorage.removeItem("productlist");
    if (RSSO) {
      if (Deal && (Deal.DealUserName != User.UserName)) {
        this.router.navigate(['/main/cart/secondary-sales']);
      } else {
        let data = [];
        this.changePswdmodalRef = this.modalService.show(SuccessDialogComponent, {
          data: {
            message: 'Please Select dealer',
            data: data
          }
        });
        this.changePswdmodalRef.content.action.subscribe(result => {
          if (result == 'OK') {
            this.changePswdmodalRef.hide();
          }
        })
      }
    }
    else {
      this.router.navigate(['/main/cart/secondary-sales']);
    }
  }

  openAdminSecondarySale() {
    let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('user'));
    sessionStorage.removeItem("currentScrollYonSession");
    sessionStorage.removeItem("pagenumber");
    sessionStorage.removeItem("productlist");
    if (RSSO) {
      if (Deal && (Deal.DealUserName != User.UserName)) {
        this.router.navigate(['/main/cart/secondary-sales-admin']);
      } else {
        let data = [];
        this.changePswdmodalRef = this.modalService.show(SuccessDialogComponent, {
          data: {
            message: 'Please Select dealer',
            data: data
          }
        });
        this.changePswdmodalRef.content.action.subscribe(result => {
          if (result == 'OK') {
            this.changePswdmodalRef.hide();
          }
        })
      }
    }
    else {
      this.router.navigate(['/main/cart/secondary-sales-admin']);
    }
  }

  openReports() {
    this.router.navigate(['/main/reports/Sales-performance?temp=user']);
  }

 
  saveDealer() {
    sessionStorage.setItem('DealUserName', JSON.stringify(this.dealerselected));
    let data = JSON.parse(sessionStorage.getItem('user'));
    if (this.dealerselected.DealUserName) {
      data['DealUserName'] = this.dealerselected.DealUserName;
    } else {
      data['DealUserName'] = data.UserName;
    }
    sessionStorage.setItem('user', JSON.stringify(data));
    window.location.reload();
  }

  clearDealer() {
    sessionStorage.setItem('DealUserName', null);
    let data = JSON.parse(sessionStorage.getItem('user'));
    data['DealUserName'] = data.UserName;
    sessionStorage.setItem('user', JSON.stringify(data));
    this.router.navigate(['/home']);
  }


  firstComponentFunction(name, type, category) {
    console.log('fffff', name)
    /*document.getElementById("dropdownMenu").style.visibility = "hidden";
    document.getElementById("dropdownMenu").style.opacity = "0";*/
    document.getElementById("dropdownMenu").style.display = "none";
    this.router.navigate(['/main/product/list']);
    setTimeout(x => {
      this.productService.filtersFromNavbar.name = name;
      this.productService.filtersFromNavbar.typeOfFilter = type;
      this.productService.filtersFromNavbar.category = category;
      console.log("2", this.productService)
      this.productService.onFirstComponentButtonClick();
    }, 100)
  }

  imagePopup : MDBModalRef;
  openAllProducts(pagename) {
    // this.imagePopup = this.modalService.show(ImagePopupComponent, {
    //   data: {
    //   }, class: "modal-md"
    // });
    // this.imagePopup.content.action.subscribe((result: any) => {
    //   if (result == 'OK') {
       //this.imagePopup.hide();  
       this.router.navigate(['/main/product/list'], { queryParams: { page: pagename } });
       this.productService.filtersFromNavbar = new NavbarFiltersAttributes();
       setTimeout(x => {
         this.productService.onFirstComponentButtonClick();
       }, 100)
     // }
    //});
  }

  openCart() {
    let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('user'));
    if (RSSO) {
      if (Deal && (Deal != User.UserName)) {
        this.router.navigate(['/main/cart/detail'])
      } else {
        let data = [];
        this.changePswdmodalRef = this.modalService.show(SuccessDialogComponent, {
          data: {
            message: 'Please Select dealer',
            data: data
          }
        });
        this.changePswdmodalRef.content.action.subscribe(result => {
          if (result == 'OK') {
            this.changePswdmodalRef.hide();
          }
        })
      }
    }
    else {
      this.router.navigate(['/main/cart/detail'])
    }
  }

  navigateTo() {
    this.router.navigate(['/main/home'])
  }

  categoryList: any[];

  // logout() {
  //   sessionStorage.clear();
  //  // window.location.assign(Config.LogoutEndpoint);
  //   // this.router.navigate(Config.LogoutEndpoint)
  //   this.router.navigate(['/login'])
  // }
 downloadFile() {
    const url = 'https://ibdindents.titan.in/Stock.xlsx';
    window.open(url, '_blank');
  }
  logout() {
   const logoutDomain=ServerBranch.getLogoutDomain();

    let sessionData = JSON.parse(sessionStorage.getItem('user')) ;
   
    let user = { UserName : sessionData.UserName }; 
    this.http 
   //IBDIENTS
    .post(logoutDomain  + '/CheckLogoutUser', JSON.stringify(user), this.cpHeaders)
    //UAT
    //.post(ServerBranch.BaseEndpoint  + '/CheckLogoutUser', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response) => {
        // Handle the API response
        this.router.navigate(['/login']);
        sessionStorage.clear();
        localStorage.clear();
       // this.cookieService.deleteAll()
      // this.clearAllCookies()
      })
      .catch((error) => {
        if (error.status === 400) {
          sessionStorage.clear();
           this.router.navigate(['/login']);
         }
        // Handle any errors
        console.error(error);
        //this.messageService.errorMessage(error.error_msg, 'error');
      });
  }




  assetsBrandFolder = 'assets/brands/';
  assetsFramesFolder = 'assets/frames/';
  brandList: any[];

  // imageArray: any[] = ['FT1002D1A1_1_lar_FT1002D1A1.jpg/', 'T2344A1A1_3_lar_T2344A1A1_4.jpg/', 'TS1020MRM1_1_lar_TS1020MRM1.jpg/', 'M165GR17G_1_lar_M165GR17G.jpg/', 'FT1081MFM3_2_FT1081MFM3_1.jpg/', 'M202BU2_1_lar_M202BU2.jpg/', 'M201BU2_1_lar_M201BU2.jpg/']
  imageArray: any[] = ['img.jpg', 'img1.jpg', 'img2.jpg', 'img3.jpg', 'img4.jpg', 'img5.jpg', 'img1.jpg']
  filtersList: any[] = [];
  getAllFilterType() {
    // this.filtersTypeArray = [];
    // this.productService.getAllFiltersType().then((data) => {
    //   // this.filtersList = data;
    //   data.forEach((item, index) => {
    //     if (item.type == 'Brand' || item.type == 'Gender' || item.type == 'Style' || item.type == 'FrameShape') {

    //       item.values.forEach((array, i) => {
    //         if(array == 'NA') {
    //           item.values.splice(i, 1)
    //         }
    //       })

    //       this.filtersList.push(item);
    //     }
    //     if(item.type == 'Brand') {
    //       this.brandList = item.values;
    //     }
    //     if(item.type == 'category') {
    //       this.categoryList = item.values;
    //       this.cartService.categorylist = this.categoryList;
    //       console.log('from nv', this.cartService.categorylist)
    //     }
    //     item.imageUrl = this.imageArray[index]
    //   })
    //   console.log('', this.brandList)
    // });
  }
  categoryLists: any[];
  categoryFilterArray: any[] = [];
  categoryFilter: any[] = [];
  categoriesFilterObject: NavbarFiltersAttributes = new NavbarFiltersAttributes()
  getAllCategories() {
    this.productService.getAllCategory().then((data: any[]) => {
      this.categoryLists = data;
      //debugger;
      for (let element of this.categoryLists) {
       // debugger
        this.productService.getFiltersByCategory(element.categoryId).then((data) => {
        //  debugger;
          console.log('sss', data)

          this.categoriesFilterObject = new NavbarFiltersAttributes();
          this.categoriesFilterObject.category = element.categoryName;
          this.categoriesFilterObject.typeOfFilter = data;
          /*this.categoriesFilterObject.typeOfFilter.forEach((array, i) => {
            if(array == 'NA') {
              this.categoriesFilterObject.typeOfFilter.splice(i, 1)
            }
          })*/
          this.categoryFilterArray.push(this.categoriesFilterObject)


        })
      }

    });
  }


  getProductTypeList() {
    this.productService.getProductTypeList().then((data: any[]) => {
      this.categoryFilter = data;
      sessionStorage.setItem("Category", JSON.stringify(data));
    });
  }

}
